import { FunctionComponent } from 'react'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import Nav from './Nav'
import Header from './Header'
import { Outlet } from "react-router-dom";
import { SPACING } from '../constants'

const App: FunctionComponent = () => {
  const styles = useStyles()

  return (
    <Box className={styles.mainContainer}>
      <Nav />
      <Box className={styles.bodyContainer}>
        <Header />
        <Box className={styles.innerContainer}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles(() => ({
  mainContainer: {
    minHeight: '100vh',
    display: 'flex'
  },
  bodyContainer: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // Flex items default to min-width:auto, so this refuses to shrink below
    // its content and anything wide inside pushes the whole shell past the
    // viewport - which is what made the page scroll sideways at 100% zoom.
    // Content that genuinely needs width scrolls within its own card.
    minWidth: 0,
  },
  innerContainer: {
    padding: SPACING * 4,
    flex: 1,
    minWidth: 0,
    overflowY: 'scroll',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      width: 0,
      height: 0,
    }
  }
}))

export default App;
